import styled from 'styled-components'

export const Box = styled.div`
  background: #fffeb5;
  padding: 15px;
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  gap: 15px;
`